module.exports = __webpack_public_path__ + "static/media/guanlirenyuan1.19b5cd16.png";